import clsx from 'clsx';
import React from 'react';
import Divider from 'ui/ds/Divider';
import {
  SelectMenu,
  SelectMenuButton,
  SelectMenuOption,
  SelectMenuOptions,
  SelectWrapper,
} from 'ui/ds/SelectMenu';
import { ArrowDown, DocumentOutlined } from 'ui/icons';

export type INavigationDropdownSections = {
  sectionHeading: string;
  items: {
    title: string;
    icon?: React.ReactNode;
    action: () => void;
    color?: string;
  }[];
}[];
export interface INavigationDropdownProps {
  sections: INavigationDropdownSections;
  defaultValue?: string;
}

const NavigationDropdown = (props: INavigationDropdownProps) => {
  const { sections = [], defaultValue = 'Menu' } = props || {};

  return (
    <SelectMenu value={defaultValue}>
      {({ open }: { open: boolean }) => {
        return (
          <>
            <SelectWrapper className="w-auto bg-transparent">
              <SelectMenuButton
                className={clsx({
                  'w-auto rounded-[10px] border border-gray-200 bg-transparent px-5 py-[7px] cursor-pointer':
                    true,
                })}
              >
                <div className="flex justify-between items-center">
                  <DocumentOutlined />
                  <ArrowDown />
                </div>
              </SelectMenuButton>
              <SelectMenuOptions
                open={open}
                className="z-20 -ml-48 max-h-min min-h-max w-72 overflow-auto p-4 px-0"
              >
                {sections.map((section, idx) => {
                  return (
                    <React.Fragment key={section?.sectionHeading}>
                      {section.sectionHeading ? (
                        <div
                          className={clsx({
                            'px-10 text-sm font-semibold text-gray-400 w-full mb-2':
                              true,
                          })}
                        >
                          {section.sectionHeading}
                        </div>
                      ) : null}
                      {section.items.map(
                        ({ title, icon: Icon = null, action, color }) => {
                          return (
                            <SelectMenuOption
                              className="flex h-12 cursor-pointer items-center gap-3 px-10 py-3"
                              key={title}
                              value={title}
                              onClick={action}
                            >
                              <div className="w-6">{Icon}</div>
                              <span
                                className={clsx({
                                  'block text-base w-full font-medium text-gray-800 leading-[132%]':
                                    true,
                                  [`text-${color}`]: Boolean(color),
                                })}
                              >
                                {title}
                              </span>
                            </SelectMenuOption>
                          );
                        }
                      )}
                      {idx !== sections.length - 1 ? (
                        <Divider wrapperClassName="py-4 mx-5" />
                      ) : null}
                    </React.Fragment>
                  );
                })}
              </SelectMenuOptions>
            </SelectWrapper>
          </>
        );
      }}
    </SelectMenu>
  );
};
export default NavigationDropdown;
